import { Component, OnInit, ViewChild, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FilterSubsectionComponent } from './filter-subsection/filter-subsection.component';
import { reportingFilter } from '../../models/filter.model';
import { scheduling } from '../../models/scheduling.model';
import { EventListenerService } from '../../services/close-listenenr.service';
import { SchedulingComponent } from '../scheduling/scheduling.component';
// import { SchedulingComponent } from '../scheduling/scheduling.component';


@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.css']
})

export class FiltersComponent implements OnInit {

  // #region Common Variables
  title: string;
  reportingType: string = '';
  currentFilters: Array<reportingFilter> = [];
  reportType: string;
  reportName: string;
  selectedCols: any;
  // #endregion

  customReport: any = null;
  currFiltersUsed: Array<string> = [];
  schedule: scheduling;


  @ViewChild('addFilter', { read: ViewContainerRef })
    viewAddFilter: ViewContainerRef;

  @ViewChild('scheduling', { read: ViewContainerRef })
    viewScheduling: ViewContainerRef;

  constructor(
    private commonService: CommonService
    , protected closeService: EventListenerService
    , private resolver: ComponentFactoryResolver
    ) { 
      this.closeService.close.subscribe(value => {
        if (value === 'scheduling') {
            this.viewScheduling.clear();
        }
      });
  }

  
  ngOnInit() {
    // add the filters as components 
    this.currentFilters.forEach(filter => {
      this.createFilterSubsection(filter);
    });
  }


  createFilterSubsection = (filter?: reportingFilter) => 
  {
    var component = this.resolver.resolveComponentFactory(FilterSubsectionComponent)
    var filterComponent = this.viewAddFilter.createComponent(component);
    (<FilterSubsectionComponent>filterComponent.instance).ref = filterComponent;
    (<FilterSubsectionComponent>filterComponent.instance).currentFilters = this.currentFilters;
    (<FilterSubsectionComponent>filterComponent.instance).currFiltersUsed = this.currFiltersUsed;
    if (filter != undefined){
      (<FilterSubsectionComponent>filterComponent.instance).thisFilter = filter;
      switch(filter.type){
        case 'ACCOUNT ID OR NAME':
            (<FilterSubsectionComponent>filterComponent.instance).filterType = 'account';
            break;
          case 'OWNER':
          case 'CREATE USER':
            (<FilterSubsectionComponent>filterComponent.instance).filterType = 'user';
            break;
          case 'BRAND':
          case 'REPORTING PERIOD':
          case 'QUOTE TYPE':
          case 'STATE':
            (<FilterSubsectionComponent>filterComponent.instance).filterType = 'dropdown';
            break;
          case 'QUOTE ID':
          case 'VENDOR REFERENCE':
          case 'VENDOR DATA':
          case 'CUSTOMER REFERENCE':
            (<FilterSubsectionComponent>filterComponent.instance).filterType = 'text';
            break;
      } 
    }
  }

   // opens the next blade in the sequence
  
  continue = () =>
  {
    if(this.viewScheduling.length > 0)
    {
      this.viewScheduling.clear();
    }

    var component = this.resolver.resolveComponentFactory(SchedulingComponent);
    var schedulingComponent = this.viewScheduling.createComponent(component);
    (<SchedulingComponent>schedulingComponent.instance).reportType = this.reportType;
    (<SchedulingComponent>schedulingComponent.instance).reportName = this.reportName;
    (<SchedulingComponent>schedulingComponent.instance).selectedCols = this.selectedCols;
    (<SchedulingComponent>schedulingComponent.instance).currentFilters = this.currentFilters;
    (<SchedulingComponent>schedulingComponent.instance).schedule = this.schedule;
    (<SchedulingComponent>schedulingComponent.instance).customReport = this.customReport;
    (<SchedulingComponent>schedulingComponent.instance).reportingType = this.reportingType;
    
    $('.child-loader').animate({ scrollLeft: 550 + 550 }, 800);
  }

  close = () => {
      this.closeService.closeEvent('filters');
  }

}

export class CustomReport {
  ReportID: number = -1;
  ReportName: string;
  LoginID: string;
  Columns: string [];
  Filters: string [] = [];
  // These 2 are strings as the are in JSON and will need to be converted
  FiltersJSON: string;
  SchedulingJSON: string;
  ReportType: string = '';
}


